import React, { Component } from 'react';
import ConfirmBox from '../../../../hoc/ConfirmBox';

class SwitchButton extends Component {
    
    state = {
      isConfirmBoxOpen:false
    }

    componentDidMount(){
      // console.log(this.props);
    }

    toggleConfirmBox = () => {
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen});
    }

    confirmButtonClick = () => {
      const {colData,id,header} = this.props;
      const eventsHandler = {
        onClick:() => (colData.clickHandler) ?
                colData.clickHandler(colData,colData.attributes):
                      'javascript(void)'
      }
      // console.log(eventsHandler);
      eventsHandler.onClick();
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen});
    }

    render () {
      const {colData,id,header} = this.props;
      const eventsHandler = {
        onClick:() => (colData.clickHandler) ?
                colData.clickHandler(colData,colData.attributes):
                      'javascript(void)'
      }
      const access_mode = (colData.access_mode==undefined)? true:colData.access_mode;
      const href = (colData.href) ? colData.href:"#";
      // console.log(eventsHandler);
        return(
            <td key={"column"+this.props.id}>
              {(access_mode==true)?
                    <div className="material-switch p-2" {...header.attributes}>
                        <input id={"module-Lead"+this.props.id}  {...colData.attributes} checked={colData.checked} type="checkbox" onClick={this.toggleConfirmBox}  />
                        <label htmlFor={"module-Lead"+this.props.id} {...colData.attributes}  className="secondary_bg"></label>
                    </div>                
              :''}

              <ConfirmBox
                isConfirmBoxOpen={this.state.isConfirmBoxOpen}
                toggleConfirmBox={this.toggleConfirmBox}
                confirmButtonClick={this.confirmButtonClick}
                content={colData.content}
              />  
              
            </td>
        );
    }
}

export default SwitchButton;